import React from "react";
import { createElementClass } from "../helpers";
export var InlineCode = function InlineCode(_a) {
  var _b = _a.inline,
      inline = _b === void 0 ? true : _b,
      value = _a.value,
      children = _a.children;
  return React.createElement("code", {
    className: createElementClass("inline-code")
  }, children === value ? value : children);
};